<template>
    <v-dialog
    v-model="isDialogOpen"
    persistent
    max-width="640">
    <v-card>
      <v-card-title class="title-form">
         {{isEdit ? 'Editar categoría':'Agregar categoría'}}
      </v-card-title>
        <v-card-text>
          <div class="container-form">

            <v-text-field
              label="Nombre de la categoría"
              placeholder="Nombre de la categoría"
              v-model="category.name"
              color="#222222"
              variant="underlined"
              type="text"
              :rules="rules.required"/>

            <v-select
              label="Asociar a POS"
              v-model="category.terminal"
              :items="pos"
              :rules="rules.required"
              item-title="name"
              item-value="_id"
              variant="underlined"/>

          </div>
        </v-card-text>
        <v-card-actions>

        <v-btn
          class="btn-cancel-form"
          color="#6E6E6E"
            variant="text"
            rounded="xl"
            @click="isDialogOpen = false">
            Cancelar
        </v-btn>

        <v-btn
            class="btn-action-form"
            rounded="xl"
            color="#FFFFFF"
            :loading="isSavingData"
            :disabled="disableBtn()"
            @click="actionBtn">
            Guardar
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>
<script>
import terminalsApi from '@/api/terminalsApi'
import categoriesApi from '@/api/categoriesApi'
export default {
  name: 'CommerciaVueAddEditCategories',
  emits: ['refreshList'],
  data () {
    return {
      business: this.$store.getters.business,
      user: this.$store.getters.user,
      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      isEdit: false,
      pos: [],
      category: this.initObj(),
      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ]
      }
    }
  },
  created () {
    this.getPos()
  },
  methods: {
    initObj () {
      return {
        edited_by: null,
        name: null,
        terminal: null,
        business: null,
        created_at: null,
        updated_at: null,
        _id: null
      }
    },
    add () {
      this.category = this.initObj()
      this.category._id = '-'
      this.category.updated_at = Date.now()
      this.category.created_at = Date.now()
      this.category.business = this.business._id
      this.category.edited_by = this.user._id
      this.isDialogOpen = true
      this.isEdit = false
    },
    edit (obj) {
      this.isDialogOpen = true
      this.isEdit = true
      this.category = structuredClone(obj)
    },
    disableBtn () {
      return (Object.values(this.category).some(value => value === null || value === ''))
    },
    actionBtn () {
      if (this.isEdit) {
        this.editCategories()
      } else {
        this.addCategories()
      }
    },
    async getPos () {
      this.pos = await terminalsApi.list(this.business._id, '')
    },
    async addCategories () {
      if (await categoriesApi.add(this.category)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
      }
    },
    async editCategories () {
      if (await categoriesApi.edit(this.category)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
      }
    }

  }
}
</script>

<style scoped>
  @import '@/assets/styles/forms.css';
</style>
